__turbopack_context__.v({
  "className": "titlefont_a829d905-module__Q6bPNG__className",
});
